import { type ReactNode } from 'react'
import { DetailsLayout } from '../details-layout/DetailsLayout'

type ScreenLayoutProps = {
  header?: ReactNode
  details?: ReactNode
  detailsLabel?: string
  mainMaxWidth?: number
  stickyDetails?: boolean
  useMobileDetailsDrawer?: boolean
  children?: ReactNode
}

export const ScreenLayout = ({
  header,
  details,
  detailsLabel,
  mainMaxWidth,
  stickyDetails,
  useMobileDetailsDrawer,
  children
}: ScreenLayoutProps) => {
  const content = (
    <>
      {header}
      {children}
    </>
  )

  if (details == null) return content

  return (
    <DetailsLayout
      details={details}
      detailsLabel={detailsLabel}
      mainMaxWidth={mainMaxWidth}
      stickyDetails={stickyDetails}
      useMobileDetailsDrawer={useMobileDetailsDrawer}
    >
      {content}
    </DetailsLayout>
  )
}
